






import Vue from "vue";
import { Component } from "vue-property-decorator";
import { DialogProgrammatic as Dialog } from "buefy";

@Component({
  components: {}
})
export default class JoinPublicViewing extends Vue {
  get publicViewingUrl(): string {
    return this.$route.path + "/public";
  }

  async handleJoinPublicViewing() {
    Dialog.confirm({
      message: this.dialogueMessage,
      cancelText: "キャンセル",
      confirmText: "ゲームを観戦する",
      onConfirm: () => this.forwardToPublicViewing()
    });
  }

  get dialogueMessage(): string {
    let msg = "";
    msg += "ゲームを観戦しますか？";
    msg += "<br/>＊見える情報は プレイヤーの村人と同程度となります";
    msg += "<br/>＊各プレイヤーの役職などはみえません";
    msg += "<br/>＊お昼後の投票などは、結果のみ見えます";

    return msg;
  }
  async forwardToPublicViewing() {
    Dialog.confirm({
      message: "観戦ページに移動します",
      canCancel: false,
      confirmText: "観戦ページに移動する",
      onConfirm: () => this.$router.push(this.publicViewingUrl)
    });
  }
}
